import { type CarrierDef } from '../common.js'
import { apiKey, password, username, userPassMap } from '../internal.js'

// TODO - legacy is collecting 'location-api-key', 'account-number', 'address-id' all for each location.  But for the 3 accounts that are provisioned - they all appear to be the same values for each location.
// are these intentionally setup that way - or was it a product of our funky cred storage system?
// it looks like it may be in between cred configurations (legacy vs details) - so that makes me think it's a product of funkiness
const credentialTypes = [
  username,
  password,
  apiKey,
  'client-id',
  'client-secret',
  'location-id',
  'tariff-header-id',
  'control-station',
  'tariff-code',
] as const
const locationCredentialTypes = ['location-api-key', 'address-id'] as const

export type paafCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const paaf: CarrierDef<paafCredType> = {
  name: 'Pilot Freight Services',
  scac: 'paaf',
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['client-id', 'apiKey'],
    ['client-secret', null],
    ['location-id', null],
    ['address-id', null],
    ['tariff-header-id', null],
    ['control-station', null],
  ],
  engineLayers: ['rating', 'pickup', 'tracking'],
}
